export function setCookie(name, value, options = {}) {
    options = { ...options };

    if (!options.domain) {
        const hostname = window.location.hostname;

        if (hostname !== 'localhost' && hostname !== '127.0.0.1' && !/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
            const parts = hostname.split('.');

            if (parts.length >= 2) {
                const secondLevelTLDs = ['co', 'com', 'gov', 'net', 'org', 'ac'];

                if (parts.length >= 3 && secondLevelTLDs.includes(parts[parts.length - 2])) {
                    options.domain = '.' + parts.slice(-3).join('.');
                } else {
                    options.domain = '.' + parts.slice(-2).join('.');
                }
            }
        }
    }

    if (!options.path) {
        options.path = '/';
    }

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += '; ' + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += '=' + optionValue;
        }
    }

    document.cookie = updatedCookie;
}
